"use strict";
exports.__esModule = true;
exports.enableScroll = void 0;
var enableScroll = function () { return document.body.classList.remove("stop-scrolling"); };
exports.enableScroll = enableScroll;
